/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{frame as r}from"../frameloop/index.js";import{useState as o,useCallback as t}from"react";import{useIsMounted as e}from"./use-is-mounted.js";function m(){const m=e(),[n,i]=o(0),p=t((()=>{m.current&&i(n+1)}),[n]);return[t((()=>r.postRender(p)),[p]),n]}export{m as useForceUpdate};
//# sourceMappingURL=use-force-update.js.map
